
//let tidingsnum = localStorage.getItem('tidingsnum')?localStorage.getItem('tidingsnum'):0;
//tidingsnum = tidingsnum*1;

let tidingsnum = 0;
//原始状态
const state = {
  tidingsnum:tidingsnum,
};
//用方法处理由state中派生出的状态
//即此状态在state中不存在 如 state中含 list 中{} 的参数
const getters = {
  
  
};
//方法集合 操作状态 state 的集合

const mutations = {
//add(state,params){
//  //console.log(params,'参数','执行mutations中的add');
//  state.addnum +=1.1;
//},
  modifyTidingsnum(state,params){
//	//console.log('store2')
  	state.tidingsnum  = params;
  },



};
//actions提交的是mutations 而不是直接改变状态
//而是通过mutations中的方法去修改
//可以异步操作
const actions = {
	modifyTidingsnum(context,params){
//		//console.log('store1')
		context.commit('modifyTidingsnum',params)
	},

//add(context,params){
//  //console.log(context,params,'参数','执行actions的add');
//  context.commit('add',params)
//},
//add({commit},params){
//  //console.log(params,'参数','执行actions的reduce');
//  commit('reduce',params)
//},

};


export default {
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/tidings.js